import React, { Component } from 'react';
class Careers extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
        <div class="container-xxl mt-5 inner_con_grey" id="careers">
            <div class="container inner_con">
                <div class="row g-4">
                <h1 class="text-start mb-1 mt-5 wow fadeInUp title_view" data-wow-delay="0.1s">Careers</h1>
                    <div class="col-lg-12 wow fadeIn margin_top_zero" data-wow-delay="0.5s">
                         <p class="mb-5 mt-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>

                     </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Careers;
